module.exports = __webpack_public_path__ + "img/TESLA Model Y Long Range.9650d639.webp";